












































































































































































import { UserModule } from "@/store/module/user";
import {
  captcha,
  getLoginQrCodeApi,
  getLoginQrCodeCheckStatusApi,
} from "@/api/staff";
import { phonePass } from "@/utils/rules";
import selectRegionPhoneNumber from "@/components/selectRegionPhoneNumber.vue";
import { PageModule } from "@/store/module/page";
import { Component, Prop, Vue } from "vue-property-decorator";
import QrcodeVue from "qrcode.vue";
@Component({
  name: "login",
  components: {
    selectRegionPhoneNumber,
    QrcodeVue,
  },
})
export default class extends Vue {
  checkTab = false;
  maxNum = 11;
  areaCodePhone = {
    checked: true,
    code: "86",
    code_id: 1,
    en_name: "China",
    name: "中国大陆",
  };
  loginForm = {
    mobile: "",
    code: "",
    area_code: "",
  };
  counter = 0;
  rules = {
    mobile: [
      { validator: phonePass, trigger: "blur" },
      { required: true, message: "请输入手机号", trigger: "blur" },
    ],
    code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
  };
  isChrome = true;
  qrCodeValue = "";
  qrCodeLoop: any = null;
  currentCodeTimeout: boolean = false;
  created() {
    let navigatorPass = true;
    // if (window.navigator.userAgent.indexOf("Edg") >= 0) {
    //   navigatorPass = false;
    // }
    if (window.navigator.userAgent.indexOf("lbbrowser") >= 0) {
      navigatorPass = false;
    }
    if (window.navigator.userAgent.indexOf("QQBrowser") >= 0) {
      navigatorPass = false;
    }
    if (window.navigator.userAgent.indexOf("maxthon") >= 0) {
      navigatorPass = false;
    }
    if (window.navigator.userAgent.indexOf("bidubrowser") >= 0) {
      navigatorPass = false;
    }
    if (window.navigator.userAgent.indexOf("Firefox") >= 0) {
      navigatorPass = false;
    }
    if (window.navigator.userAgent.indexOf("Chrome") < 0) {
      navigatorPass = false;
    }
    this.isChrome = navigatorPass;
    this.getQrcode();
  }
  async login() {
    this.loginForm.area_code = this.areaCodePhone.code;
    await UserModule.LoginIn(this.loginForm);
  }
  async submitForm() {
    (this.$refs["loginForm"] as Vue & { validate: Function }).validate(
      async (v: boolean) => {
        if (v) {
          this.login();
        }
      }
    );
  }
  stopCodeLoop() {
    clearInterval(this.qrCodeLoop);
  }
  // 扫码登录
  getQrcode() {
    this.currentCodeTimeout = false;
    getLoginQrCodeApi({
      type: "ts_web_login",
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.qrCodeValue = "type=ts_web_login&code=" + res.data.code;
        this.qrCodeLoop = setInterval(() => {
          getLoginQrCodeCheckStatusApi({
            type: "ts_web_login",
            code: res.data.code,
          }).then((r: any) => {
            if (r.error_code === 0) {
              if (r.data) {
                this.$message({
                  message: "登录成功",
                  type: "success",
                });
                UserModule.qrCodeLoginIn(r.data.token);
                clearInterval(this.qrCodeLoop);
              }
            } else if (
              r.error_code === 18022004 ||
              r.error_code === 18022005 ||
              r.error_code === 18022014
            ) {
              this.$message({
                message: "登录失败：" + r.message,
                type: "error",
              });
              clearInterval(this.qrCodeLoop);
            } else if (r.error_code === 18022002) {
              // 二维码已被使用，重新发一个
              this.$message({
                message: "二维码已被使用，请重新扫码",
                type: "error",
              });
              clearInterval(this.qrCodeLoop);
              this.getQrcode();
            } else {
              this.$message({
                message: "登录失败",
                type: "error",
              });
              clearInterval(this.qrCodeLoop);
            }
          });
        }, 2000);
        // 3分钟二维码过期
        setTimeout(() => {
          this.currentCodeTimeout = true;
          clearInterval(this.qrCodeLoop);
        }, 3 * 60 * 1000);
      }
    });
  }
  getCode() {
    if (this.counter > 0) {
      return false;
    }
    const mobile = this.loginForm.mobile;
    if (!mobile) {
      this.$message({
        type: "error",
        message: "请先填写手机号",
      });
      return false;
    }
    captcha({
      mobile: String(mobile),
      event: "login",
      area_code: String(this.areaCodePhone.code),
    }).then((res) => {
      (this.$refs["code"] as Vue & { focus: Function }).focus();
      this.counter = 60;
      const countdown = setInterval(() => {
        const after = this.counter - 1;
        this.counter = after;
        if (after === 0) {
          clearInterval(countdown);
        }
      }, 1000);
    });
  }
  areaCode(data: any) {
    PageModule.SET_PAGE_INFO({
      name: "areaCodePhoneNumber",
      key: "area_code",
      value: data[0].code,
    });
    if (data) {
      this.areaCodePhone = data[0];
      if (
        data[0].code !== "86" &&
        data[0].code !== "852" &&
        data[0].code !== "853" &&
        data[0].code !== "886"
      ) {
        this.maxNum = 16;
        return;
      } else if (data[0].code === "852" || data[0].code === "853") {
        this.maxNum = 8;
        return;
      } else if (data[0].code === "886") {
        this.maxNum = 10;
        return;
      } else {
        this.maxNum = 11;
        return;
      }
    }
  }
  beforeDestroy() {
    clearInterval(this.qrCodeLoop);
    PageModule.SET_PAGE_INFO({
      name: "areaCodePhoneNumber",
      key: "area_code",
      value: "",
    });
  }
}
